import React from 'react';
import Routes from './routes';
import './styles.css';

const App = () => <Routes />;
export default App;
